;
define("error_management_internal_error.tpl", function(){});

